import { TableDescriptions } from '../@types/interfaces/table-interface';

export const COLUNA_DIFERENCA_PERCENTUAL = 'percVariacao';
const MIGRACAO_COLUNA_VISIVEL = 'is-compras.percVariacao.visivel';

type StorageMinimo = Pick<Storage, 'getItem' | 'setItem'>;

export function colunasComDiferencaPercentual(
  salvas: TableDescriptions[] | null | undefined,
  padrao: TableDescriptions[],
  storage: StorageMinimo
): { colunas: TableDescriptions[]; persistir: boolean } {
  const base = Array.isArray(salvas) && salvas.length > 0 ? salvas.map((coluna) => ({ ...coluna })) : padrao.map((coluna) => ({ ...coluna }));
  const definicao = padrao.find((coluna) => coluna.dataField === COLUNA_DIFERENCA_PERCENTUAL);
  if (!definicao) {
    return { colunas: base, persistir: false };
  }

  let persistir = false;
  const indice = base.findIndex((coluna) => coluna.dataField === COLUNA_DIFERENCA_PERCENTUAL);
  if (indice < 0) {
    base.push({ ...definicao, hidden: false });
    persistir = true;
  }

  if (storage.getItem(MIGRACAO_COLUNA_VISIVEL) !== '1') {
    const posicao = base.findIndex((coluna) => coluna.dataField === COLUNA_DIFERENCA_PERCENTUAL);
    if (posicao >= 0 && base[posicao].hidden !== false) {
      base[posicao] = { ...base[posicao], hidden: false };
      persistir = true;
    }
    storage.setItem(MIGRACAO_COLUNA_VISIVEL, '1');
  }

  return { colunas: base, persistir };
}
